
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Patientbodywarmermanufacrul() {



  const cardData =
  {
    keyword: 'Patient Body Warmer Manufacturers in India',
    heading: 'Pharmacle Health Care Private Limited: Patient Body Warmer Manufacturers in India',
    headingDescription: 'Pharmacle Health Care Private Limited is one of the leading Patient Body Warmer Manufacturers in India, offering reliable and efficient warming solutions to maintain patient body temperature during surgeries and critical procedures. Our state-of-the-art body warmers are designed to prevent hypothermia and ensure optimal thermal regulation for improved patient outcomes. Trusted by top hospitals and healthcare institutions across the country, our products are easy to operate, technologically advanced, and meet high safety standards. Choose Pharmacle Health Care for top-quality patient body warmers made in India to enhance surgical care and recovery.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',


"topPlaces": [
  {
    "title": "Top Patient Body Warmer Manufacturers in India",
    "description": "Pharmacle Health Care Private Limited is one of India’s leading manufacturers of patient body warmers, delivering innovative thermal management systems designed to maintain normothermia in hospitals and surgical centers."
  },
  {
    "title": "Best Quality Patient Body Warmers Manufactured in India",
    "description": "Ensure superior patient care with high-performance body warmers from Pharmacle Health Care Private Limited — trusted across India for safe, reliable, and effective hypothermia prevention solutions."
  },
  {
    "title": "Leading Manufacturer of Patient Body Warmers in India",
    "description": "Pharmacle Health Care Private Limited specializes in designing and manufacturing advanced patient body warmers that support surgical theaters, ICUs, and critical care units across India."
  },
  {
    "title": "Reliable Patient Warming Equipment Manufacturer in India",
    "description": "Hospitals across India depend on Pharmacle Health Care Private Limited for reliable patient warming equipment that ensures precise body temperature regulation during medical and surgical procedures."
  },
  {
    "title": "India’s Trusted Supplier of Patient Body Warmers",
    "description": "As a top-rated manufacturer, Pharmacle Health Care Private Limited provides safe, efficient, and easy-to-use patient body warmers tailored for hospitals, clinics, and emergency care in India."
  },
  {
    "title": "High-Performance Body Warmers by Indian Manufacturer",
    "description": "Experience consistent and controlled thermal support with Pharmacle Health Care Private Limited’s body warmers — proudly manufactured in India to meet international quality and safety standards."
  },
  {
    "title": "Patient Body Warming Devices Manufactured in India",
    "description": "Pharmacle Health Care Private Limited manufactures industry-grade patient warming devices in India, built to international standards for accuracy, reliability, and patient comfort."
  },
  {
    "title": "Top-Rated Patient Body Warmer Manufacturing Company in India",
    "description": "Recognized for innovation, safety, and clinical excellence, Pharmacle Health Care Private Limited is a top-rated patient body warmer manufacturer serving healthcare institutions nationwide."
  },
  {
    "title": "Buy Directly from India’s Best Patient Body Warmer Manufacturer",
    "description": "Get premium warming devices directly from Pharmacle Health Care Private Limited — India’s most trusted manufacturer with robust nationwide distribution and after-sales support."
  },
  {
    "title": "Affordable and Advanced Patient Body Warmers – Made in India",
    "description": "Pharmacle Health Care Private Limited delivers affordable yet advanced patient body warmers, engineered in India to improve surgical safety, post-operative recovery, and patient comfort."
  }
],

   "services": [
    {
        "name": "Patient Body Warmer Manufacturers India",
        "description": "Pharmacle Health Care is one of the leading patient body warmer manufacturers in India, offering advanced systems designed to regulate body temperature during medical procedures. These devices help prevent hypothermia and improve patient safety and comfort."
    },
    {
        "name": "India Patient Body Warmers",
        "description": "We supply India patient body warmers built for maintaining optimal body temperature during surgeries and recovery. These warmers support clinical efficiency and enhance patient outcomes."
    },
    {
        "name": "Patient Body Warming Devices India",
        "description": "Pharmacle Health Care provides reliable patient body warming devices in India, crucial for preventing hypothermia during operations and critical care. These devices ensure thermal stability and patient well-being."
    },
    {
        "name": "Surgical Body Warmer India",
        "description": "Our surgical body warmers in India are designed to maintain patient temperature during surgical procedures. They play a key role in improving surgical outcomes and reducing complications."
    },
    {
        "name": "Patient Heating Equipment India",
        "description": "We offer patient heating equipment across India for safe and effective body temperature regulation during medical treatments, ensuring patient safety and comfort."
    },
    {
        "name": "Medical Body Warmer Systems",
        "description": "Pharmacle Health Care delivers medical body warmer systems engineered for consistent temperature control during clinical procedures, supporting patient care standards and recovery efficiency."
    },
    {
        "name": "Hospital Body Warmer Devices",
        "description": "Our hospital body warmer devices are suitable for various medical settings, helping maintain normothermia and supporting overall patient health and recovery."
    },
    {
        "name": "Clinical Body Warming Machine India",
        "description": "We provide clinical body warming machines in India, designed for high-performance temperature regulation during surgical and post-operative care."
    },
    {
        "name": "Patient Thermoregulation Systems India",
        "description": "Pharmacle Health Care offers patient thermoregulation systems in India to manage and maintain body temperature during medical interventions, reducing the risk of hypothermia and enhancing patient outcomes."
    }
],
"tableData": [
    ["- Patient Body Warmer Manufacturers India", "- India Patient Body Warmers"],
    ["- Patient Body Warming Devices India", "- Surgical Body Warmer India"],
    ["- Patient Heating Equipment India", "- Medical Body Warmer Systems"],
    ["- Hospital Body Warmer Devices", "- Clinical Body Warming Machine India"],
    ["- Patient Thermoregulation Systems India"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "As leading Patient Body Warmer Manufacturers in India, we provide advanced warming systems designed to offer precise temperature control during medical procedures. Our technology ensures reliable performance, preventing hypothermia and enhancing patient safety across healthcare facilities in India."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We offer a wide range of Patient Body Warmers across India, including warming devices, blankets, and temperature control systems. Our solutions are designed for patient comfort and safety, making sure individuals remain warm and comfortable during medical treatments."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our Patient Body Warmers are manufactured to the highest industry standards, ensuring durability and long-lasting performance. Regularly tested for optimal functionality, our systems provide continuous, reliable support for medical settings across India."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "We prioritize patient safety and comfort in every product. Our Patient Body Warmers deliver controlled warmth to prevent temperature-related complications during medical procedures, ensuring patients across India receive the best care possible."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our patient body warming systems in India are designed to meet the specific needs of diverse healthcare settings, from hospitals to clinics. We collaborate with healthcare providers to deliver adaptable and effective solutions for patient care."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Our Patient Body Warmers are designed to seamlessly integrate with existing medical systems in India. Whether in an operating room or patient care area, our products can be easily implemented without disrupting ongoing procedures or treatment."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We offer expert consultation services across India to help healthcare facilities choose the ideal Patient Body Warmer systems. Our team also provides continuous support and maintenance to ensure your equipment remains operational and effective."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are at the core of our values. Our Patient Body Warmers are meticulously designed to prevent temperature-related issues during critical medical procedures, providing optimal care for every patient in India."
    }
]
















  }

  const faqData = [
    {
      question: "Who are the leading Patient Body Warmer manufacturers in India?",
      answer: "Pharmacle Health Care Private Limited is one of the leading Patient Body Warmer manufacturers in India. They provide advanced warming solutions that help maintain optimal patient body temperature during surgeries and other medical procedures."
    },
    {
      question: "What types of Patient Body Warmers does Pharmacle Health Care offer?",
      answer: "Pharmacle Health Care offers Forced Air Warming Systems designed to deliver consistent and safe warming through specialized blankets or pads. These systems are suitable for a wide range of surgical and clinical settings."
    },
    {
      question: "Why choose Pharmacle Health Care for Patient Body Warmers in India?",
      answer: "Pharmacle Health Care is known for its high-quality medical devices, reliable customer support, and commitment to patient safety. Their warming systems are trusted by healthcare facilities across India."
    },
    {
      question: "Can Pharmacle Health Care deliver Patient Body Warmers across India?",
      answer: "Yes, Pharmacle Health Care Private Limited provides nationwide delivery of Patient Body Warmers, ensuring that hospitals and clinics across India can access their advanced warming technology."
    },
    {
      question: "Does Pharmacle Health Care provide after-sales support for Patient Body Warmers?",
      answer: "Yes, Pharmacle Health Care offers complete after-sales support, including installation, training, and maintenance services to ensure optimal use of their Patient Body Warming Systems."
    }
  ];
  
  const testimonialsData = [
    {
      text: "We’ve been using patient warming systems from Pharmacle Health Care for over a year. Their products are reliable and have greatly improved patient temperature management during surgeries.",
      name: "Dr. Neha Sharma, Mumbai General Hospital"
    },
    {
      text: "Pharmacle Health Care's Patient Body Warmers are efficient, easy to use, and backed by excellent customer service. A trusted partner in surgical care.",
      name: "Sunrise Multispeciality Clinic, Delhi"
    }
  ];
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];



  
  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Patient Body Warmer Manufacturers in India",
    "description": "Discover top Patient Body Warmer Manufacturers in India. We provide high-quality patient body warming devices, surgical body warmers, and hospital body warmer equipment designed for medical use and patient thermoregulation.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.8",
      "ratingCount": "1247"
    }
  };
  
 
  

  

  return (
    <div>
 <Helmet>
    <title>Patient Body Warmer Manufacturers in India | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Find leading Patient Body Warmer Manufacturers in India. Offering clinical body warming machines, patient heating equipment, and medical thermoregulation systems. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Patient Body Warmer Manufacturers India, India Patient Body Warmers, Patient Body Warming Devices India, Surgical Body Warmer India, Patient Heating Equipment India, Medical Body Warmer Systems, Hospital Body Warmer Devices, Clinical Body Warming Machine India, Patient Thermoregulation Systems India"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/45.png' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Patientbodywarmermanufacrul;